import React, {useEffect, useState} from 'react'
import Homepage from './Homepage';

const LandingPage = () => {
     const paramsString = window.location.search;
    const searchParams = new URLSearchParams(paramsString);
    const whichStep = searchParams.get('step');

    const [revealStep, setRevealStep] = useState(whichStep === 'website' ? 'website' : null);
    const [directlyWebsite, setDirectlyWebsite] = useState(whichStep !== 'website');
    const [curtainsRevealed, setCurtainsRevealed] = useState(false);
    const [containerHeight, setContainerHeight] = useState("100vh");
    
     useEffect(() => {
        if (revealStep === 'website' && curtainsRevealed && containerHeight === "100vh") {
        const timer = setTimeout(() => {
            setContainerHeight("unset");
        }, 1000);
        return () => clearTimeout(timer);
        }
    }, [revealStep, curtainsRevealed, containerHeight]);

    const onClick = () =>{
    setCurtainsRevealed(true);
    window.history.replaceState({}, "", window.location.pathname);
    }           
    
    const renderContentToBeRevealed = () => {
        return <Homepage />;
    };

    if (directlyWebsite) return <Homepage />;

    const computedStyle = {};
    if (curtainsRevealed && revealStep === 'website') {
        computedStyle.width = 0;
    }
    return (
        <div className="curtain" style={{ height: containerHeight, overflow: curtainsRevealed? "visible": "hidden" }}>
        <div className="curtain_wrapper">

            {/* Trigger Click Box */}
            <button
                className="curtain_trigger_box"
                style={{ display: curtainsRevealed ? 'none' : 'initial' }}
                onClick={onClick}
            ></button>

            {/* Left Curtain */}
            <div
            className={`${'curtain_panel'} ${'curtain_panel_left'} ${curtainsRevealed ? 'reveal_left' : ""}`}
            style={computedStyle}
            ></div>

            {/* Content */}
            {renderContentToBeRevealed()}

            {/* Right Curtain */}
            <div
            className={`${'curtain_panel'} ${'curtain_panel_right'} ${curtainsRevealed ? 'reveal_right' : ""}`}
            style={computedStyle}
            ></div>
        </div>
    </div>
    )
}

export default LandingPage